<template>
  <div class="animated fadeIn CheckinDDAT">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} {{ aLang.csd_title }}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item
                      :label="aLang.csd_checkIn_time"
                      prop="thoi_diem_check_in"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_diem_check_in
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.csd_tourists">
                      <!-- <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.nguoi_check_in_id
                        "
                        clearable
                        filterable
                        placeholder="Nhập từ khóa để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_findNguoiCheckin"
                        @keyup.enter.native="fn_findNguoiCheckin"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFindNguoiCheckin"
                          :key="item.id"
                          :label="item.ho_ten.ho_ten"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->

                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="nguoi_check_in"
                        :fetch-suggestions="querySearchNguoiCheckin"
                        :placeholder="aLang.csd_enter_keywords_to_search"
                        :trigger-on-focus="false"
                        @select="handleSelectNguoiCheckin"
                        @change="handleSelectNguoiCheckin"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3" v-if="aRole('Admin,Officer')">
                    <el-form-item :label="aLang.csd_safe_destination">
                      <!-- <el-input
                        v-model="mData.tableRules.dataSearch.value.diem_den_an_toan_id"
                        clearable
                      ></el-input>-->

                      <!-- <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.diem_den_an_toan_id
                        "
                        clearable
                        filterable
                        placeholder="Nhập từ khóa để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_findDDAT"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFindDDAT"
                          :key="item.id"
                          :label="item.thong_tin_chung.ten"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_diem_den_an_toan"
                        :fetch-suggestions="querySearchTenDDAT"
                        :placeholder="aLang.csd_enter_keywords_to_search"
                        :trigger-on-focus="false"
                        @select="handleSelectTenDDAT"
                        @change="handleSelectTenDDAT"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.thong_tin_chung.ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.csd_created_object">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.doi_tuong_thuc_hien
                        "
                        clearable
                        :placeholder="aLang.c_select"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listImplementationObject"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row style="margin-bottom: 5px;">
          <b-col xl="10" md="12" sm="12">
            <div class="text-left mb-2">
              <el-form
                :model="mData.dataFormCheckin"
                :rules="mData.validFormCheckin"
                ref="myFormCheckin"
                class="mr-3"
                v-if="aRole('SafePlace')"
              >
                <el-button
                  class="mr-3"
                  style="float: left; font-size: 24px; padding: 3px 6px"
                  type="info"
                  icon="fa fa-qrcode"
                  plain
                  @click="mData.dialog.scan = true"
                  v-if="aRole('SafePlace')"
                >
                </el-button>
                <el-form-item v-show="false" prop="cardCode" class="mr-3" style="float: left;">
                  <el-input
                    v-model="mData.dataFormCheckin.cardCode"
                    type="text"
                    :placeholder="aLang.csd_travel_card_code"
                    clearable
                    @keyup.enter.native="fn_handleCheckin('create')"
                    style="width: 200px;"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="cardCode" class="mr-3" style="float: left;">
                  <el-input
                    v-model="mData.dataFormCheckin.cardCode"
                    type="text"
                    :placeholder="aLang.csd_travel_card_code"
                    clearable
                    @keyup.enter.native="fn_handleCheckin('create')"
                    style="width: 200px;"
                ></el-input>
                </el-form-item>
              </el-form>
              <div class="button_wrap">
                <el-button
                  v-ladda
                  @click="fn_handleCheckin('create')"
                  type="success"
                  plain
                  v-if="aRole('SafePlace')"
                >
                  {{ aLang.c_showCheckin }}
                </el-button>
                <el-button
                  @click="fn_openModalQrcode()"
                  type="warning"
                  plain
                  v-if="aRole('SafePlace')"
                >
                  {{ aLang.c_showQrcode }}
                </el-button>
                <el-button
                  class="huong_dan"
                  @click="fn_openModalHDDGDDAT()"
                  type="primary"
                  plain
                  v-if="aRole('SafePlace')"
                >
                  {{ aLang.c_showHDDGDDAT }}
                </el-button>
                <el-button
                  class="tai_app"
                  @click="fn_openModalTaiapp()"
                  type="danger"
                  plain
                  v-if="aRole('SafePlace')"
                >
                  {{ aLang.c_showTaiapp }}
                </el-button>
              </div>
            </div>
          </b-col>
          <b-col xl="2" md="12" sm="12">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="460"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1]
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          />
          <el-table-column
            prop="thoi_diem_check_in"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.csd_checkIn_time"
            width="170"
            :formatter="fn_formatterDatetime"
            align="center"
          />
          <el-table-column
            prop="ten_nguoi_tao"
            :label="aLang.csd_created_object"
            min-width="250"
          />
          <el-table-column
            prop="ten_nguoi_check_in"
            :label="aLang.csd_tourists"
            min-width="250"
          />
          <el-table-column
            :label="aLang.csd_avatar"
            width="70"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.avatar_url" title="Xem chi tiết" @click="showDetailImage(scope.row.avatar_url)">
                <i class="fas fa-portrait" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="so_the"
            :label="aLang.tr_card_number"
            width="160"
          />
          <el-table-column
            prop="ngay_sinh"
            :label="aLang.tr_bod"
            width="120"
            align="center"
          />
          <el-table-column
            prop="gioi_tinh"
            label="Giới tính"
            width="120"
          />
          <el-table-column
            prop="so_giay_to"
            :label="aLang.itcc_identity"
            width="130"
          />
          <el-table-column
            :label="aLang.csd_front"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.anh_cmnd_mat_truoc" title="Xem chi tiết" @click="showDetailImage(scope.row.anh_cmnd_mat_truoc)">
               <i class="fas fa-address-card" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="aLang.csd_backside"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.anh_cmnd_mat_sau" title="Xem chi tiết" @click="showDetailImage(scope.row.anh_cmnd_mat_sau)">
                <i class="far fa-address-card" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="dia_chi"
            label="Địa chỉ"
            min-width="250"
          />
          <el-table-column
            prop="dien_thoai"
            :label="aLang.csd_phone_number"
            width="130"
          />
          <el-table-column
            prop="email"
            label="Email"
            min-width="200"
          />
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
            <el-button
              @click="fn_exportExcelCheckIn()"
              type="primary"
              icon="el-icon-download"
              plain
              v-if="aRole('SafePlace')"
            >
              Tải danh sách
            </el-button>
          </div>
          <div class="col-md-8 text-right pagination-wrap">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
        <el-form>
          <b-row>
            <b-col md="4" class="p-0"></b-col>
            <b-col md="8">
              <div class="text-right mb-2 mt-5">
                <el-button @click="displayChart(7)" type="info" plain
                  >{{aLang.csd_last_7_days}}</el-button
                >
                <el-button @click="displayChart(30)" type="info" plain
                  >{{aLang.csd_last_30_days}}</el-button
                >
              </div>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <default-bar-chart
              :configBarChart="mData.configChart"
              ref="barChart"
            ></default-bar-chart>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- modal Qrcode -->
    <el-dialog
      id="check-in-ddat-qr"
      :close-on-click-modal="false"
      title="QR CODE"
      :visible.sync="mData.dialog.Qrcode"
      min-width="18rem"
      class="qr_code_wrap"
      top="25px"
      font-size="13px"
    >
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myFormQrcode"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <!-- <p class="text-center" style="word-break: break-word;font-size:15px;"> {{aLang.csd_check_scan_qr_code}} </p> -->
              <el-form-item class="text-center mt-3 mb-0 card-body-custom">
                <div id="bg-qr" class="bg-qr" >
                  <div
                    ref="bg"
                    class="qr-frame"
                    style="margin: 0 auto;"
                  >
                    <img :src="mData.srcQr" alt="" style="max-height: 100%;">
                    <!-- <div ref="qr" class="text-center mt-8 qr-custom" :style="{ left: cssStyle.qrPosionLeft, top: cssStyle.qrPosionTop, width: cssStyle.qrWidth }">
                      <qr-code
                        :text="mData.dataDefault.qrcodeId"
                        error-level="H"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div> -->
                  </div>
                </div>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button @click="mData.dialog.Qrcode = false" type="info" plain>{{
              aLang.c_close
            }}</el-button>
            <el-button @click="printQR(mData.srcQr)" type="info" plain>{{aLang.csd_print_qr}}</el-button>
            <el-button @click="dowloadQR(mData.srcQr,'qrCode')" type="info" plain>{{aLang.csd_download_qr}}</el-button>
            <!-- <el-button @click="dowloadQR(mData.srcQr)" type="info" plain>Tải QR</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- modal HDDGDDAT -->
    <el-dialog
      id="check-in-ddat-qr"
      :close-on-click-modal="false"
      title="Hướng dẫn đánh giá điểm đến"
      :visible.sync="mData.dialog.HDDGDDAT"
      min-width="18rem"
      class="qr_code_wrap"
      top="25px"
      font-size="13px"
    >
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myFormQrcode"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <!-- <p class="text-center" style="word-break: break-word;font-size:15px;"> {{aLang.csd_check_scan_qr_code}} </p> -->
              <el-form-item class="text-center mt-3 mb-0 card-body-custom">
                <div id="bg-qr" class="bg-qr" >
                  <div
                    ref="bg"
                    class="qr-frame"
                    style="margin: 0 auto;"
                  >
                    <img :src="mData.srcQRHddgddat" alt="" style="max-height: 100%;">
                    <!-- <div ref="qr" class="text-center mt-8 qr-custom" :style="{ left: cssStyle.qrPosionLeft, top: cssStyle.qrPosionTop, width: cssStyle.qrWidth }">
                      <qr-code
                        :text="mData.dataDefault.qrcodeId"
                        error-level="H"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div> -->
                  </div>
                </div>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button @click="mData.dialog.HDDGDDAT = false" type="info" plain>{{
              aLang.c_close
            }}</el-button>
            <el-button @click="printQR(mData.srcQRHddgddat)" type="info" plain>{{aLang.csd_print_qr}}</el-button>
            <el-button @click="dowloadQR(mData.srcQRHddgddat,'hddk')" type="info" plain>{{aLang.csd_download_qr}}</el-button>
            <!-- <el-button @click="dowloadQR(mData.srcQr)" type="info" plain>Tải QR</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- modal Taiapp -->
    <el-dialog
      :close-on-click-modal="false"
      title="Tải app"
      :visible.sync="mData.dialog.Taiapp"
      class="qr_code_download"
      width="35%"
      top="60px"
      font-size="13px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormTaiapp"
          :rules="mData.validFormTaiapp"
          ref="myFormTaiapp"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <!-- <el-form-item label="Mã thẻ/Mã MS" prop="cardCode">
                <el-input v-model="mData.dataFormTaiapp.cardCode" clearable></el-input>
              </el-form-item>-->
            </b-col>
            <!-- <b-col md="6">
              <el-form-item label="App Android">
                <a
                  href="https://play.google.com/store/apps/details?id=com.biin.tourism"
                  target="_blank"
                >1. App cho khách du lịch</a>
                <br />
                <a
                  href="https://play.google.com/store/apps/details?id=com.biin.tourism.guide"
                  target="_blank"
                >2. App cho điểm đến</a>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="App IOS">
                <a
                  href="https://apps.apple.com/us/app/biin-tourism/id1486739313"
                  target="_blank"
                >1. App cho khách du lịch</a>
                <br />
                <a
                  href="https://apps.apple.com/us/app/h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-vi%C3%AAn-du-l%E1%BB%8Bch-vi%E1%BB%87tnam/id1489028074"
                  target="_blank"
                >2. App cho hướng dẫn viên</a>
              </el-form-item>
            </b-col>-->
            <b-col md="12" class="text-center mt-3 bottom-border">
              <!-- <el-form-item
                label="App cho khách du lịch"
                class="text-center mt-3"
              > -->
                <!-- <img
                  :src="mData.dataDefault.linkApp.kdlImgUrl"
                  width="142"
                  style="border-radius: 10%;"
                  alt
                />
                <img src="img/appkdl.png" height="142" width="142" style="border-radius: 10%;" />
                <br /> -->
                <h5 style="word-break: break-word;">App Du lịch Việt Nam</h5>
                <b-row>
                  <b-col md="12">
                    <img
                      width="60%"
                      :src="mData.dataDefault.linkApp.kdlImgUrl"
                      style="border-radius: 10%;"
                      alt
                    />
                  </b-col>
                  <!-- <b-col md="5" class="p-2">
                    <div class="qr-wrapper">
                      <img src="/img/qr-app-kdl.png" alt="" class="qr-icon">
                      <qr-code
                        :text="mData.dataDefault.linkApp.androidKdlUrl"
                        error-level="M"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div>
                    <el-link
                      class="cell-child"
                      target="_blank"
                      :href="mData.dataDefault.linkApp.androidKdlUrl"
                      :underline="false"
                    >Android</el-link>
                  </b-col>
                  <b-col md="2" class="d-flex flex-column align-items-center justify-content-center p-2">
                    <img src="/img/appkdl.png" alt="" class="app-logo">
                  </b-col>
                  <b-col md="5" class="p-2">
                    <div class="qr-wrapper">
                      <img src="/img/qr-app-kdl.png" alt="" class="qr-icon">
                      <qr-code
                        :text="mData.dataDefault.linkApp.iosKdlUrl"
                        error-level="M"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div>
                    <el-link
                      class="cell-child"
                      target="_blank"
                      :href="mData.dataDefault.linkApp.iosKdlUrl"
                      :underline="false"
                    >iOS</el-link>
                  </b-col> -->
                </b-row>
              <!-- </el-form-item> -->
            </b-col>
            <b-col md="12" class="text-center mt-3">
              <!-- <el-form-item
                label="App cho hướng dẫn viên"
                class="text-center mt-3"
              > -->
                <!-- <img
                  :src="mData.dataDefault.linkApp.hdvImgUrl"
                  width="142"
                  style="border-radius: 10%;"
                  alt
                /> -->
                <!-- <img src="img/apphdv.png" height="142" width="142" style="border-radius: 10%;" /> -->
                <!-- <br /> -->
                <h5 style="word-break: break-word;">App Quản trị và Kinh doanh du lịch</h5>
                <b-row>
                  <b-col md="12">
                    <img
                      width="60%"
                      :src="mData.dataDefault.linkApp.hdvImgUrl"
                      style="border-radius: 10%;"
                      alt
                    />
                  </b-col>
                  <!-- <b-col md="5" class="p-2">
                    <div class="qr-wrapper">
                      <img src="/img/qr-icon.jpg" alt="" class="qr-icon">
                      <qr-code
                        :text="mData.dataDefault.linkApp.androidHdvUrl"
                        error-level="M"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div>
                    <el-link
                      class="cell-child"
                      target="_blank"
                      :href="mData.dataDefault.linkApp.androidHdvUrl"
                      :underline="false"
                    >Android</el-link>
                  </b-col>
                  <b-col md="2" class="d-flex flex-column align-items-center justify-content-center p-2">
                    <img src="/img/apphdv.png" alt="" class="app-logo">
                  </b-col>
                  <b-col md="5" class="p-2">
                    <div class="qr-wrapper">
                      <img src="/img/qr-icon.jpg" alt="" class="qr-icon">
                      <qr-code
                        :text="mData.dataDefault.linkApp.iosHdvUrl"
                        error-level="M"
                        :size="1024"
                        class="qr-code"
                      ></qr-code>
                    </div>
                    <el-link
                      class="cell-child"
                      target="_blank"
                      :href="mData.dataDefault.linkApp.iosHdvUrl"
                      :underline="false"
                    >iOS</el-link>
                  </b-col> -->
                </b-row>

              <!-- </el-form-item> -->
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleTaiapp('create')"
            >{{aLang.c_update}}</el-button>-->
            <el-button @click="mData.dialog.Taiapp = false" type="info" plain>{{
              aLang.c_close
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="ScanQR" :visible.sync="mData.dialog.scan" width="350px">
      <div class="d-flex justify-content-center flex-column p-2">
        <div class="width: 300px; heigth: 300px;" v-if="mData.dialog.scan">
          <QrcodeStream @decode="onDecode" />
        </div>
        <!-- <p class="text-center mt-2">{{ mData.dataDefault.QRCode || "" }}</p> -->
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dialog.scan = false">Đóng</el-button>
        <el-button
          type="primary"
          @click="
            mData.dialog.scan = false;
            mData.dataFormCheckin.cardCode = mData.dataDefault.QRCode;
          "
          >Nhập Qr</el-button
        >
      </span> -->
    </el-dialog>
    <!-- modal Decode  -->
    <!-- user  tp-->
    <el-dialog :visible.sync="mData.dialog.modalUser" width="360px">
      <div class="d-flex justify-content-center flex-column p-4">
        <div
          class="width: 300px; heigth: 300px;"
          v-if="mData.dialog.modalUser"
        ></div>
        <div class="block text-center mb-2">
          <el-avatar :size="60" :src="circleUrl" class="el-avatar-d"></el-avatar>
        </div>
        <p style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_fullname}}:{{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.dataForeignerQr.ho_chieu.ho_ten
                : ""
            }`
          }}
        </p>
        <p style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_passport}}:{{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.dataForeignerQr.ho_chieu.so_ho_chieu
                : ""
            }`
          }}
        </p>
       <p style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_qr_code}}:
          {{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.dataForeignerQr.qr
                : ""
            }`
          }}
        </p>

        <p v-if="mData.dataDefault.dataForeignerQr&&mData.dataDefault.dataForeignerQr.visa && mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet&&mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet!=undefined" style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_visa_approved_time}}:{{
            ` ${
              mData.dataDefault.dataForeignerQr && mData.dataDefault.dataForeignerQr.visa
                ? mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet
                : ""
            }`
          }}
        </p>

       <p v-if="mData.dataDefault.profileVisa" style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_user_visa_approved}}:
          {{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.profileVisa.ho_ten.ho_ten
                : ""
            }`
          }}
        </p>
       <p style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_entry_time}}:{{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.dataForeignerQr.nhap_canh
                    .thoi_diem_nhap_canh
                : ""
            }`
          }}
        </p>
       <p style="word-break: break-word;font-weight:700;color:#111">
          {{aLang.csd_user_approved}}:
          {{
            ` ${
              mData.dataDefault.dataForeignerQr
                ? mData.dataDefault.profileNhapCanh.ho_ten.ho_ten
                : ""
            }`
          }}
        </p>
      </div>
      <div
        slot="footer"
        class="dialog-footer d-flex justify-content-around pl-3 pr-3"
      >
        <el-button @click="mData.dialog.modalUser = false" type="danger"
          >{{aLang.csd_cancel}}</el-button
        >
        <el-button
          type="warning"
          style="background-color: orange"
          @click="[(mData.dialog.modalUser = false), fn_handleCheckinQr()]"
          >{{aLang.csd_approved}}</el-button
        >
      </div>
    </el-dialog>
    <!-- info  -->
    <el-dialog :visible.sync="mData.dialog.modalInfo" width="380px">
      <div
        class="d-flex justify-content-center flex-column p-3"
        style="border-radius:10px"
      >
        <div
          class="width: 300px; heigth: 300px;"
          v-if="mData.dialog.modalInfo"
        ></div>
        <div
          style="font-weight:600; color:#111; font-size:20px"
          class="text-center"
        >
          {{aLang.csd_tourist_information}}
        </div>
        <div class="d-flex flex-content-around align-items-center">
          <div class="block">
            <el-avatar :size="50" :src="circleUrlInfo"  class="el-avatar-d"></el-avatar>
          </div>
          <div class="desc d-flex flex-column justify-content-center ml-2">
            <div class="d-flex">
              <p style="word-break: break-word;font-weight:500" class="pr-2 mb-0">{{aLang.csd_phone_number}}:</p>
              <p style="word-break: break-word;color:#111; font-weight:700" class="mb-0">
                {{
                  mData.dataDefault.dataQrKhachDuLich
                    ? mData.dataDefault.dataQrKhachDuLich.dien_thoai
                    : ""
                }}
              </p>
            </div>
            <div class="d-flex">
              <p style="word-break: break-word;font-weight:500;" class="pr-2 mb-2">
                {{aLang.csd_fullname}}:
              </p>
              <p style="word-break: break-word;color:#111; font-weight:700" class="mb-2">
                {{
                  mData.dataDefault.dataQrKhachDuLich
                    ? mData.dataDefault.dataQrKhachDuLich.ho_ten.ho_ten
                    : ""
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- <div v-if="mData.dataDefault.tieu_chi">
          <div style="color:#111; font-weight:700">
            {{aLang.csd_safety_criteria}}
          </div>
          <div class="mt-2 tc-des ml-2  scroll-bar" style="overflow-y:scroll; max-height:280px;scrollbar-width: none">
            <div
              v-for="(item, index) in mData.dataDefault.tieu_chi"
              :key="item.id"
            >
              <p v-if="item == 1" style="word-break	: break-word;">
                {{ index + 1 }}. Khách phải được đo thân nhiệt khi đến giao
                dịch, làm việc và sử dụng dịch vụ du lịch; thực hiện các biện
                pháp phòng ngừa dịch bệnh theo hướng dẫn của cơ quan y tế; tuân
                thủ sự bố trí của các cơ sở kinh doanh dịch vụ du lịchnhằm đảm
                bảo giãn cách an toàn.
              </p>
              <p v-if="item == 2" style="word-break	: break-word;">
                {{ index + 1 }}. Khách phải đeo khẩu trang trừ khi ở tại phòng
                ngủ, khi ăn, uống tại bàn ăn trong nhà hàng và quầy bar.
              </p>
              <p v-if="item == 3" style="word-break	: break-word;">
                {{ index + 1 }}. Che mũi, miệng khi ho, hắt hơi đặc biệt trong
                lúc ăn uống không đeo khẩu trang. Phải bỏ khăn, giấy che mũi
                miệng vào đúng nơi quy định.
              </p>
              <p v-if="item == 4" style="word-break	: break-word;">
                {{ index + 1 }}. Giữ thái độ phối hợp đối với cơ quan chức năng
                và nhân viên cơ sở kinh doanh dịch vụ du lịch. Thông báo cho cơ
                quan chức năng nếu có biểu hiện mắc bệnh COVID-19 sau khi rời
                khỏi cơ sở kinh doanh dịch vụ du lịch.
              </p>
              <p v-if="item == 5" style="word-break	: break-word;">
                {{ index + 1 }}. Thực hiện các quy định khác của cơ sở kinh
                doanh du lịch.
              </p>
            </div>
          </div>
        </div> -->
      </div>
      <div
        slot="footer"
        class="dialog-footer d-flex justify-content-around pl-3 pr-3"
      >
        <el-button @click="mData.dialog.modalInfo = false" type="danger"
          >Huỷ</el-button
        >
        <el-button
          type="warning"
          style="background-color: orange"
          @click="[(mData.dialog.modalInfo = false), fn_handleCheckinQr()]"
          >Đồng ý</el-button
        >
      </div>
    </el-dialog>
    <!-- Dialog chi tiết ảnh -->
    <el-dialog
      title="Chi tiết"
      :visible.sync="imageDialogVisible"
      width="40%"
      :before-close="handleCloseImageDialog"
      :close-on-click-modal="false"
    >
      <div>
        <el-image :src="urlImageDetail" fit="contain" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import CheckinDDATModel from "./CheckinDDATModel";
import DefaultBarChart from "../../../component/DefaultBarChart";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import AccountApi from "../../../moduleApi/AccountApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import DangKyDDATModel from "../DangKyDDAT/DangKyDDATModel";
import PhienBanApi from "../../../moduleApi/PhienBanApi";
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import ForeignerApi from "../../../moduleApi/ForeignerApi";
import DangKyChuongTrinhApi from "../../../moduleApi/DangKyChuongTrinhApi";
import { QrcodeStream } from "vue-qrcode-reader";
import moment from "moment";
import html2canvas from 'html2canvas';
export default {
  components: {
    DefaultBarChart,
    QrcodeStream
  },
  data() {
    return {
      imageDialogVisible: false,
      urlImageDetail: undefined,
      nguoi_check_in:'',
      ten_diem_den_an_toan:'',
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      circleUrlInfo:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        currentUser: MethodService.getCurrentUser(),
        srcQr: "",
        srcQRHddgddat: "",
        moduleName: "CheckinDDAT", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(CheckinDDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listDDAT: [],
          listImplementationObject: DataService.implementationObject,
          listNguoiCheckin: [],
          listNguoiTao: [],
          listNguoiTaoKDL: [],
          listFindNguoiCheckin: [],
          listFindDDAT: [],
          currentUser: {},
          dataExport: [],
          qrcodeId: "",
          linkApp: {},
          listUserCheckIn: [],
          Checkin: {
            viewMode: "create",
            indexModal: undefined
          },
          Qrcode: {
            viewMode: "create",
            indexModal: undefined
          },
          Taiapp: {
            viewMode: "create",
            indexModal: undefined
          },
          QRCode: "",
          dataForeignerQr: null,
          profileVisa: null,
          profileNhapCanh: null,
          dataQrKhachDuLich: null,
          tieu_chi: null
        },
        dataForm: MethodService.copyObject(CheckinDDATModel.dataForm),
        dataSafeplace: undefined,
        validForm: CheckinDDATModel.validForm,
        dataFormCheckin: MethodService.copyObject(
          CheckinDDATModel.dataFormOther.check_in
        ),
        validFormCheckin: CheckinDDATModel.validFormOther.check_in,
        dialog: {
          Checkin: false,
          Qrcode: false,
          HDDGDDAT: false,
          Taiapp: false,
          scan: false,
          modalUser: false,
          modalInfo: false
        },
        configChart: {
          title: "",
          titleX: "Ngày",
          titleY: "Số lượt",
          dataPoint: []
        }
      },
    };
  },
  computed: {
      getModalInfo() {
          return this.mData.dialog.modalInfo
      },
      getModalUser() {
          return this.mData.dialog.modalUser
      },
      stringStrim(str){
        return str.strim();
      }
  },
  watch: {
      getModalInfo() {
        this.checkBody()
      },
      getModalUser() {
        this.checkBody()
      }
  },
  methods: {
    showDetailImage(urlImage) {
      this.imageDialogVisible = true
      this.urlImageDetail = urlImage
    },
    handleCloseImageDialog() {
      this.imageDialogVisible = false
      setTimeout(() => {
        this.urlImageDetail = undefined
      }, 500)
    },
    //get list table
    printQR(src) {
      const wndPrint = window.open("about:blank", 'QR code Điểm đến', "width=700,height=800,toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
      if (!wndPrint) {
        window.toastr.error("Tính năng in không hoạt động do trình duyệt của bạn đang chặn Popup. Hãy cho phép hiển thị Popup để sử dụng được tính năng này!");
        return ;
      }
      let style = wndPrint.document.createElement("style");
      style.innerHTML = "img { margin: 0 auto; display: block; max-width: 100%; max-height: 100%; height:750px;}";
      let imgDOM = document.createElement("img");
      imgDOM.src = "http:" + src;
      wndPrint.document.body.appendChild(style);
      wndPrint.document.body.appendChild(imgDOM);
      setTimeout(() => {
        wndPrint.print();
        wndPrint.focus();
      }, 500)

    },
    async dowloadQR(imageSrc,type){
      let fileName = "";
      if(type == "hddk"){
        fileName =  "QR_HDĐK_" +this.mData.dataDefault.currentUser.account + ".jpg";
      }else if( type == "qrCode"){
        fileName =  "QR_Code_" +this.mData.dataDefault.currentUser.account + ".jpg";
      }
      const image = await fetch(imageSrc);
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);

      const link = document.createElement('a');
      link.href = imageURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async fn_initTable() {
      // if(this.mData.currentUser.roles.includes("SafePlace")){
      //   this.fn_getDataExport();
      // }
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        }).catch(err => {});
      }

      let res = await CheckinDDATApi.list(dataFilter)
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(CheckinDDATModel.dataForm),
        res.result
      )
      let ddatIds = MethodService.findListItemDifferent(
        resData,
        "diem_den_an_toan_id"
      )
      let nguoitaoIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_tao_id"
      )
      Promise.all([
        DiemDenAnToanApi.list({
          limit: ddatIds.length,
          filters: "id:in:" + ddatIds.join(",")
        }),
        KhachDuLichApi.list({
          limit: this.mData.dataDefault.listUserCheckIn.length,
          filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(",")
        }),
        ProfileApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(",")
        }),
        KhachDuLichApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(",")
        })
      ]).then(response => {
        this.mData.dataDefault.listDDAT = response[0].result;
        this.mData.dataDefault.listNguoiCheckin = response[1].result;
        this.mData.dataDefault.listNguoiTao = response[2].result;
        this.mData.dataDefault.listNguoiTaoKDL = response[3].result;
        setTimeout(() => {
          let resDataAfterChange = this.fn_changeData(resData);
          this.mData.tableRules.data = resDataAfterChange;
          this.mData.tableRules.total = res.meta.total;
          this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
          console.log("this.mData.tableRules.data",this.mData.tableRules.data);
          if (
            this.mData.tableRules.offset == res.meta.total &&
            this.mData.tableRules.offset != 0
          ) {
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.page = 1;
            this.fn_initTable();
          }
          this.mData.srcQRHddgddat = window.MyConfig.hostApi + 'qrcode-board.jpg?rnd=' + new Date().getTime() + '&code=' + this.mData.dataDefault.currentUser.account;
          this.mData.srcQr = window.MyConfig.hostApi + 'qrDuLich.jpg?rnd=' + new Date().getTime() + '&code=' + this.mData.dataDefault.currentUser.account;
          this.displayChart(7);
        }, 1000)
      })
    },
    fn_changeData(resData){
      // let resDDATApi = await DiemDenAnToanApi.list({
      //   limit: ddatIds.length,
      //   filters: "id:in:" + ddatIds.join(",")
      // });
      // let resNguoiCheckin = await KhachDuLichApi.list({
      //   limit: this.mData.dataDefault.listUserCheckIn.length,
      //   filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(",")
      // });
      // let resNguoiTao = await ProfileApi.list({
      //   limit: nguoitaoIds.length,
      //   filters: "id:in:" + nguoitaoIds.join(",")
      // });
      // let resNguoiTaoKDL = await KhachDuLichApi.list({
      //   limit: nguoitaoIds.length,
      //   filters: "id:in:" + nguoitaoIds.join(",")
      // });

      // this.mData.dataDefault.listDDAT = resDDATApi.result;
      // this.mData.dataDefault.listNguoiCheckin = resNguoiCheckin.result;
      // this.mData.dataDefault.listNguoiTao = resNguoiTao.result;
      // this.mData.dataDefault.listNguoiTaoKDL = resNguoiTaoKDL.result;
      resData.forEach(item => {
        let diemDenAnToan = this.mData.dataDefault.listDDAT.find(element => {
          return element.id == item.diem_den_an_toan_id;
        });
        if (diemDenAnToan) {
          item.ten_dien_dien_an_toan = diemDenAnToan.thong_tin_chung.ten;
        } else {
          item.ten_dien_dien_an_toan = "";
        }

        let nguoiCheckin = this.mData.dataDefault.listNguoiCheckin.find(
          element => {
            return element.id == item.nguoi_check_in_id;
          }
        );
        if (nguoiCheckin) {
          if (nguoiCheckin.ho_ten && nguoiCheckin.ho_ten.ho_ten && nguoiCheckin.ho_ten.ho_ten.trim() != "") {
            item.ten_nguoi_check_in = nguoiCheckin.ho_ten.ho_ten;
          } else {
            item.ten_nguoi_check_in = "Chưa có thông tin";
          }
          if (nguoiCheckin.dien_thoai) {
            item.dien_thoai = nguoiCheckin.dien_thoai;
          } else {
            item.dien_thoai = "Chưa có thông tin";
          }
          if (nguoiCheckin.so_the) {
            item.so_the = nguoiCheckin.so_the;
          } else {
            item.so_the = "Chưa có thông tin";
          }
          if (nguoiCheckin.avatar_url) {
            item.avatar_url = nguoiCheckin.avatar_url;
          }
          if (nguoiCheckin.anh_cmnd) {
            if (nguoiCheckin.anh_cmnd.mat_truoc) item.anh_cmnd_mat_truoc = nguoiCheckin.anh_cmnd.mat_truoc
            if (nguoiCheckin.anh_cmnd.mat_sau) item.anh_cmnd_mat_sau = nguoiCheckin.anh_cmnd.mat_sau
          }
          if (nguoiCheckin.ngay_sinh && nguoiCheckin.ngay_sinh.ngay_sinh) {
            item.ngay_sinh = MethodService.formatDate(nguoiCheckin.ngay_sinh.ngay_sinh,"date");
          }else{
            item.ngay_sinh = "Chưa có thông tin";
          }
          if (nguoiCheckin.gioi_tinh) {
            item.gioi_tinh =  nguoiCheckin.gioi_tinh == 1 ? "Nữ" :
                              nguoiCheckin.gioi_tinh == 2 ? "Nam" :
                              nguoiCheckin.gioi_tinh == 3 ? "Chưa có thông tin" :
                              nguoiCheckin.gioi_tinh == 4 ? "Khác" : "";
          } else {
            item.gioi_tinh = "Chưa có thông tin";
          }
          if (nguoiCheckin.giay_to && nguoiCheckin.giay_to.length > 0 && nguoiCheckin.giay_to[0].so_giay_to) {
            item.so_giay_to = nguoiCheckin.giay_to[0].so_giay_to;
          } else {
            item.so_giay_to = "Chưa có thông tin";
          }
          if (nguoiCheckin.dia_chi && nguoiCheckin.dia_chi.dia_chi) {
            item.dia_chi = nguoiCheckin.dia_chi.dia_chi;
          } else {
            item.dia_chi = "Chưa có thông tin";
          }
          if(nguoiCheckin.email){
            item.email = nguoiCheckin.email;
          } else {
            item.email = "Chưa có thông tin";
          }
        } else {
          item.ten_nguoi_check_in = "Chưa có thông tin";
          item.dien_thoai = "Chưa có thông tin";
          item.ngay_sinh = "Chưa có thông tin";
          item.gioi_tinh = "Chưa có thông tin";
          item.so_giay_to = "Chưa có thông tin";
          item.dia_chi = "Chưa có thông tin";
          item.email = "Chưa có thông tin";
        }

        let nguoiTao = this.mData.dataDefault.listNguoiTao.find(element => {
          return element.id == item.nguoi_tao_id;
        });
        if (nguoiTao) {
          if(nguoiTao.ho_ten && nguoiTao.ho_ten.ho_ten && nguoiTao.ho_ten.ho_ten.trim() != ""){
            item.ten_nguoi_tao = nguoiTao.ho_ten.ho_ten;
          }else{
            item.ten_nguoi_tao = "Chưa có thông tin";
          }

        } else {
          let nguoiTaoKDL = this.mData.dataDefault.listNguoiTaoKDL.find(
            element => {
              return element.id == item.nguoi_tao_id;
            }
          );
          if (nguoiTaoKDL) {
            if(nguoiTaoKDL.ho_ten && nguoiTaoKDL.ho_ten.ho_ten && nguoiTaoKDL.ho_ten.ho_ten.trim() != ""){
              item.ten_nguoi_tao = nguoiTaoKDL.ho_ten.ho_ten;
            }else{
              item.ten_nguoi_tao = "Chưa có thông tin";
            }
          } else {
            item.ten_nguoi_tao = "Chưa có thông tin";
          }
        }
      });
      return resData;
    },
    async fn_getDataExport(){
      let dataFilter = {
        filters: this.mData.tableRules.filters
      }
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = 1000000;
      }
      let res = await CheckinDDATApi.list(dataFilter)
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(CheckinDDATModel.dataForm),
        res.result
      )
      let ddatIds = MethodService.findListItemDifferent(
        resData,
        "diem_den_an_toan_id"
      )
      let nguoitaoIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_tao_id"
      )
      Promise.all([
        DiemDenAnToanApi.list({
          limit: ddatIds.length,
          filters: "id:in:" + ddatIds.join(",")
        }),
        KhachDuLichApi.list({
          limit: this.mData.dataDefault.listUserCheckIn.length,
          filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(",")
        }),
        ProfileApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(",")
        }),
        KhachDuLichApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(",")
        })
      ]).then(response => {
        this.mData.dataDefault.listDDAT = response[0].result;
        this.mData.dataDefault.listNguoiCheckin = response[1].result;
        this.mData.dataDefault.listNguoiTao = response[2].result;
        this.mData.dataDefault.listNguoiTaoKDL = response[3].result;
        setTimeout(() => {
          let resDataAfterChange = this.fn_changeData(resData)
          // this.mData.dataDefault.dataExport = resDataAfterChange;
          MethodService.exportExcelCheckinDDAT(resDataAfterChange)
        })
      })
    },
    async fn_exportExcelCheckIn(){
      // MethodService.exportExcelCheckinDDAT(this.mData.dataDefault.dataExport);
      this.fn_getDataExport()
    },
    async displayChart(ngay) {
      let ngay_hien_tai = new Date();
      let dataFilter = {
        // filters: "diem_den_an_toan_id:in:" + this.mData.dataDefault.listDDAT.id,
      };
      dataFilter.limit = this.mData.tableRules.total;
      let resCheckin = await CheckinDDATApi.list(dataFilter);
      let resDataCheckin = resCheckin.result;

      var resultArr = [];
      var dateArr = [];
      resDataCheckin.forEach(item => {
        let yDate = new Date(item.thoi_diem_check_in);
        // Easiest way to get your required date format
        let xDate =
          (ngay_hien_tai.getTime() - yDate.getTime()) / (1000 * 3600 * 24);
        if (xDate <= ngay) {
          var date = yDate
            .toISOString()
            .replace(/T/, " ")
            .split(" ")[0];
          var index = dateArr.indexOf(date);
          if (index == -1) {
            dateArr.push(date);
            var obj = {
              label: MethodService.formatDate(item.thoi_diem_check_in, "date"),
              y: 1,
              _t: item.thoi_diem_check_in
            };
            resultArr.push(obj);
          } else {
            resultArr[index].y++;
          }
        }
      });
      resultArr.sort((a, b) => (a._t > b._t ? 1 : b._t > a._t ? -1 : 0));
      this.mData.configChart.dataPoint = resultArr;

      if (ngay == 7) {
        this.mData.configChart.title = "Biểu đồ check-in 7 ngày gần nhất";
      } else if (ngay == 30) {
        this.mData.configChart.title = "Biểu đồ check-in 30 ngày gần nhất";
      }

      this.$refs["barChart"].displayCharts();
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        }).catch(err => {});
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        }).catch(err => {});
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        }).catch(err => {});
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },
    cancelModalCheckin(){
     this.mData.dataFormCheckin.cardCode = "";
    },
    async fn_handleCheckinQr() {
      let khachDuLichId;
      this.mData.dataFormCheckin.cardCode = this.mData.dataDefault.QRCode;

      let resNguoiCheckinId = await AccountApi.getUserIdOrFetchAcsUser(
        this.mData.dataFormCheckin
      );
      // debugger;
      if (resNguoiCheckinId.result) {
        khachDuLichId = resNguoiCheckinId.result;
      } else {
        khachDuLichId = null;
      }

      this.mData.dataForm.nguoi_check_in_id = khachDuLichId;
      this.mData.dataForm.diem_den_an_toan_id = "";
      // let currentUser = MethodService.getCurrentUser();
      // if (currentUser) {
      if (this.mData.dataDefault.currentUser) {
        let resDDAT = await DiemDenAnToanApi.list({
          filters: "nguoi_tao_id:in:" + this.mData.dataDefault.currentUser.id
        });
        // debugger;
        if (resDDAT.result && resDDAT.result.length > 0) {
          this.mData.dataForm.diem_den_an_toan_id = resDDAT.result[0].id;
        }
      }
      if (khachDuLichId != null) {
        await CheckinDDATApi.create(this.mData.dataForm);
        // debugger;
        this.mData.dialog.Checkin = false;
        this.mData.dataFormCheckin.cardCode = "";
        MethodService.stopLadda();
        this.fn_initTable();
      } else {
        window.toastr.error("Mã thẻ/Mã MS không tồn tại");
      }
    },
    async fn_handleCheckin(type) {

      if (type == "create") {

        this.$refs["myFormCheckin"].validate(async valid => {
          if (valid) {
            this.mData.dataFormCheckin.cardCode = this.mData.dataFormCheckin.cardCode.trim();
            // let item = MethodService.copyObject(this.mData.dataFormCheckin);
            if (this.mData.dataFormCheckin.cardCode == null) {
              window.toastr.error("Vui lòng nhập mã thẻ du lịch!");
              MethodService.stopLadda();
              return;
            }
            let khachDuLichId;
            // let resKhachDuLich = await KhachDuLichApi.list({
            //   filters: "so_the:in:" + this.mData.dataFormCheckin.cardCode
            // });

            // if (resKhachDuLich.result && resKhachDuLich.result.length > 0) {
            //   khachDuLichId = resKhachDuLich.result[0].id;
            // } else {
            //   khachDuLichId = null;
            // }

            let resNguoiCheckinId = await AccountApi.getUserIdOrFetchAcsUser(
              this.mData.dataFormCheckin
            );
            // debugger;
            if (resNguoiCheckinId.result) {
              khachDuLichId = resNguoiCheckinId.result;
            } else {
              khachDuLichId = null;
            }

            this.mData.dataForm.nguoi_check_in_id = khachDuLichId;
            this.mData.dataForm.diem_den_an_toan_id = "";
            // let currentUser = MethodService.getCurrentUser();
            // if (currentUser) {
            if (this.mData.dataDefault.currentUser) {
              let resDDAT = await DiemDenAnToanApi.list({
                filters:
                  "nguoi_tao_id:in:" + this.mData.dataDefault.currentUser.id
              });
              // debugger;
              if (resDDAT.result && resDDAT.result.length > 0) {
                this.mData.dataForm.diem_den_an_toan_id = resDDAT.result[0].id;
              }
            }
            if (khachDuLichId != null) {
              await CheckinDDATApi.create(this.mData.dataForm);
              // debugger;
              this.mData.dialog.Checkin = false;
              this.mData.dataFormCheckin.cardCode = "";
              MethodService.stopLadda();
              await this.fn_initDataDefault()
              await this.fn_initTable();
            } else {
              window.toastr.error("Mã thẻ/Mã MS không tồn tại");
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      // if (type == "update") {
      //   this.$refs["myFormCheckin"].validate(async valid => {
      //     if (valid) {
      //       let item = MethodService.copyObject(this.mData.dataFormCheckin);

      //       this.$refs["myFormCheckin"].resetFields();
      //       this.mData.dialog.Checkin = false;

      //       MethodService.stopLadda();
      //     } else {
      //       MethodService.stopLadda();
      //       return false;
      //     }
      //   });
      // }
    },

    //delete
    async fn_delete(id) {
      await CheckinDDATApi.delete(id);
      this.fn_initTable();
    },

    fn_openModalCheckin(type, id) {
      this.mData.dialog.Checkin = true;

      if (type == "create") {
        this.mData.dataDefault.Checkin.indexModal = undefined;
        this.mData.dataDefault.Checkin.viewMode = type;
        this.mData.dataFormCheckin = MethodService.copyObject(
          TourModel.dataFormOther.check_in
        );
      } else {
        this.mData.dataDefault.Checkin.indexModal = id;
        this.mData.dataDefault.Checkin.viewMode = type;
        // this.mData.dataFormCheckin = MethodService.copyObject(
        //   this.mData.dataForm.hanh_trinh[id]
        // );
      }
    },
    async fn_openModalQrcode(){
       this.mData.dialog.Qrcode = true;

      if (this.mData.dataDefault.currentUser) {
        // let resDDAT = await DiemDenAnToanApi.list({
        //   filters: "nguoi_tao_id:in:" + this.mData.dataDefault.currentUser.id
        // });
        // // debugger;
        // if (resDDAT.result && resDDAT.result.length > 0) {
        //   this.mData.dataDefault.qrcodeId = resDDAT.result[0].id;
        // }
        this.mData.dataDefault.qrcodeId = this.mData.dataDefault.currentUser.account;
      }
    },
    async fn_openModalHDDGDDAT() {
      this.mData.dialog.HDDGDDAT = true;

      if (this.mData.dataDefault.currentUser) {
        // let resDDAT = await DiemDenAnToanApi.list({
        //   filters: "nguoi_tao_id:in:" + this.mData.dataDefault.currentUser.id
        // });
        // // debugger;
        // if (resDDAT.result && resDDAT.result.length > 0) {
        //   this.mData.dataDefault.qrcodeId = resDDAT.result[0].id;
        // }
        this.mData.dataDefault.qrcodeId = this.mData.dataDefault.currentUser.account;
      }
    },
    async fn_openModalTaiapp() {
      let resPhienBan = await PhienBanApi.list({ limit: 1000 });
      let listPhienBan = resPhienBan.result;
      // debugger;
      let androidKdlUrlLink = "";
      let iosKdlUrlLink = "";
      let androidHdvUrlLink = "";
      let iosHdvUrlLink = "";

      if (listPhienBan && listPhienBan.length > 0) {
        let _androidKdlUrlLink = listPhienBan.find(
          element => element.platform == "KDL.ANDROID"
        );
        if (_androidKdlUrlLink) androidKdlUrlLink = _androidKdlUrlLink.link;

        let _iosKdlUrlLink = listPhienBan.find(
          element => element.platform == "KDL.IOS"
        );
        if (_iosKdlUrlLink) iosKdlUrlLink = _iosKdlUrlLink.link;

        let _androidHdvUrlLink = listPhienBan.find(
          element => element.platform == "HDV.ANDROID"
        );
        if (_androidHdvUrlLink) androidHdvUrlLink = _androidHdvUrlLink.link;

        let _iosHdvUrlLink = listPhienBan.find(
          element => element.platform == "HDV.IOS"
        );
        if (_iosHdvUrlLink) iosHdvUrlLink = _iosHdvUrlLink.link;
      }

      this.mData.dataDefault.linkApp = {
        hdvImgUrl: "/img/qr-app-hdv.jpg",
        kdlImgUrl: "/img/qr-app-kdl.png",
        androidKdlUrl: androidKdlUrlLink,
        iosKdlUrl: iosKdlUrlLink,
        androidHdvUrl: androidHdvUrlLink,
        iosHdvUrl: iosHdvUrlLink
      };
      this.mData.dialog.Taiapp = true;
    },

    //event table
    async querySearchNguoiCheckin(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }
      let resNguoiCheckin = await KhachDuLichApi.list({
        limit: this.mData.dataDefault.listUserCheckIn.length,
        filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(",")
      });
      let findNguoiCheckin = resNguoiCheckin.result.filter( item => {
        return item.ho_ten && item.ho_ten.ho_ten && item.ho_ten.ho_ten.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      }
      );

      var results = queryString
        ? findNguoiCheckin.filter(
            item =>
              item.ho_ten.ho_ten
                .toLowerCase()
                .includes(queryString.toLowerCase())
          )
        :findNguoiCheckin;
        this.mData.tableRules.dataSearch.value.nguoi_check_in_id = ''
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectNguoiCheckin(item) {
      this.mData.tableRules.dataSearch.value.nguoi_check_in_id = item.id;
      console.log('item tùm nè', item)
      this.nguoi_check_in = item.ho_ten && item.ho_ten.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : ''
    },
    async querySearchTenDDAT(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }
      let resDDAT = await DiemDenAnToanApi.list({
        limit: 1000,
        filters: `thong_tin_chung.ten:regex_i:${queryString}`
      });
      if (resDDAT.result && resDDAT.result.length > 0) {
        this.mData.dataDefault.listFindDDAT = resDDAT.result;
      }
      var results = queryString
        ?  this.mData.dataDefault.listFindDDAT.filter(
            item =>
              item.thong_tin_chung.ten
                .toLowerCase()
                .includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listFindDDAT;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectTenDDAT(item) {
      this.mData.tableRules.dataSearch.value.diem_den_an_toan_id = item.id;
      this.ten_diem_den_an_toan = item.thong_tin_chung && item.thong_tin_chung.ten ? item.thong_tin_chung.ten : ''
    },

    async fn_findNguoiCheckin(query) {
      query = query.trim();
      if (!query) {
        this.mData.dataDefault.listFindNguoiCheckin = [];
        return;
      }
      let resNguoiCheckin = await KhachDuLichApi.list({
        limit: this.mData.dataDefault.listUserCheckIn.length,
        filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(",")
      });
      let findNguoiCheckin = resNguoiCheckin.result.filter(
        item =>
        item.ho_ten && item.ho_ten.ho_ten && item.ho_ten.ho_ten.toLowerCase().indexOf(query.toLowerCase()) > -1
      );

      if (resNguoiCheckin.result && resNguoiCheckin.result.length > 0) {
        this.mData.dataDefault.listFindNguoiCheckin = findNguoiCheckin;
      }
      // debugger
    },
    async fn_findDDAT(query) {
      query = query.trim();
      if (!query) {
        return;
      }
      let resDDAT = await DiemDenAnToanApi.list({
        limit: 1000,
        filters: `thong_tin_chung.ten:regex_i:${query}`
      });
      if (resDDAT.result && resDDAT.result.length > 0) {
        this.mData.dataDefault.listFindDDAT = resDDAT.result;
      }
    },

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";

          this.fn_initTable();
          // this.fn_getDataExport();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      }).catch(err => {});
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {
      let currentUserObj = MethodService.getCurrentUser();
      this.mData.dataDefault.currentUser = currentUserObj;
      // console.log(this.mData.dataDefault.currentUser);
      if (MethodService.checkRole("SafePlace")) {
        DiemDenAnToanApi.clearCache();
        let resCheck = await DiemDenAnToanApi.list({
          filters: "nguoi_tao_id:in:" + currentUserObj.id
        });
        //   this.mData.tableRules.data = res.result;

        if (resCheck.result && resCheck.result.length > 0) {
          this.mData.dataSafeplace = resCheck.result[0]
          let resGiayTo = [];
          let resDiaChi = [];
          let resNguoiDaiDien = [];
          let resForm = [];
          if (
            resCheck.result[0].thong_tin_chung.giay_to &&
            resCheck.result[0].thong_tin_chung.giay_to != null
          ) {
            resGiayTo = MethodService.checkDifferentObject(
              MethodService.copyObject(DangKyDDATModel.dataFormOther.giay_to),
              resCheck.result[0].thong_tin_chung.giay_to
            );
          } else {
            resGiayTo = MethodService.copyObject(
              DangKyDDATModel.dataFormOther.giay_to
            );
          }

          if (
            resCheck.result[0].thong_tin_chung.dia_chi &&
            resCheck.result[0].thong_tin_chung.dia_chi != null
          ) {
            resDiaChi = MethodService.checkDifferentObject(
              MethodService.copyObject(DangKyDDATModel.dataFormOther.dia_chi),
              resCheck.result[0].thong_tin_chung.dia_chi
            );
          } else {
            resDiaChi = MethodService.copyObject(
              DangKyDDATModel.dataFormOther.dia_chi
            );
          }

          if (
            resCheck.result[0].thong_tin_chung.nguoi_dai_dien &&
            resCheck.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resNguoiDaiDien = MethodService.checkDifferentObject(
              MethodService.copyObject(
                DangKyDDATModel.dataFormOther.nguoi_dai_dien
              ),
              resCheck.result[0].thong_tin_chung.nguoi_dai_dien
            );
          } else {
            resNguoiDaiDien = MethodService.copyObject(
              DangKyDDATModel.dataFormOther.nguoi_dai_dien
            );
          }

          if (
            resCheck.result[0].thong_tin_chung.nguoi_dai_dien &&
            resCheck.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resForm = MethodService.checkDifferentObject(
              MethodService.copyObject(DangKyDDATModel.dataForm),
              resCheck.result[0]
            );
          } else {
            resForm = MethodService.copyObject(DangKyDDATModel.dataForm);
          }

          if (
            !resForm ||
            !resForm.thong_tin_chung ||
            !resForm.thong_tin_chung.nguoi_dai_dien ||
            !resForm.thong_tin_chung.dia_chi ||
            !resForm.thong_tin_chung.nguoi_dai_dien.ho_ten ||
            // !resForm.thong_tin_chung.nguoi_dai_dien.chuc_vu ||
            // !resForm.thong_tin_chung.nguoi_dai_dien.ngay_sinh ||
            !resForm.thong_tin_chung.nguoi_dai_dien.so_giay_to ||
            // !resForm.thong_tin_chung.nguoi_dai_dien.dia_chi ||
            !resForm.thong_tin_chung.nguoi_dai_dien.dien_thoai ||
            !resForm.thong_tin_chung.ten ||
            !resForm.loai_diem_den ||
            !resForm.thong_tin_chung.dia_chi.tinh_id ||
            !resForm.thong_tin_chung.dia_chi.xa_id ||
            !resForm.thong_tin_chung.dia_chi.dia_chi
          ) {
            this.$confirm();
            this.$confirm(
              "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
              {
                confirmButtonText: LanguageService.lang.c_agree,
                showClose: false,
                showCancelButton: false,
                type: "warning"
              }
            )
              .then(() => {
                this.$router.push({
                  name: "Admin-DangKyDDAT-update",
                  params: { id: resForm.id }
                }).catch(err => {});
              })
              .catch(() => {
                this.$router.push({
                  name: "Admin-DangKyDDAT-update",
                  params: { id: resForm.id }
                }).catch(err => {});
              });
          }
        }
      }
      await this.getListKDL();
    },
    async getListKDL() {
      try {
        let dataFilter = {}
        if(this.mData.currentUser.roles.includes("SafePlace")){
          dataFilter = {
            ddat_id: this.mData.dataSafeplace.id
          }
        }
        const resApi = await CheckinDDATApi.getKhachDuLich(dataFilter)
        this.mData.dataDefault.listUserCheckIn = MethodService.findListItemDifferent(
          resApi.result,
          "Nguoi_check_in_id"
        )
      } catch (error) {
        console.log('error', error)
      }
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.nguoi_check_in_id) {
        let resProfile = await KhachDuLichApi.findById(
          this.mData.tableRules.dataSearch.value.nguoi_check_in_id
        );
        if (resProfile.result) {
          this.mData.dataDefault.listFindNguoiCheckin.push(resProfile.result);
          this.nguoi_check_in = this.mData.dataDefault.listFindNguoiCheckin[0].ho_ten.ho_ten
        }
      }
      if (this.mData.tableRules.dataSearch.value.diem_den_an_toan_id) {

        let resDDATApi = await DiemDenAnToanApi.findById(
          this.mData.tableRules.dataSearch.value.diem_den_an_toan_id
        );
        if (resDDATApi.result) {
          this.ten_diem_den_an_toan  = resDDATApi.result.thong_tin_chung.ten
        }
      }
    },
    async onDecode(decodedString) {
      // let a = decodedString;
      // debugger;
      if(decodedString.substr(0,1)==0 && decodedString.length==10){
      decodedString = "84" + decodedString.substring(decodedString.length - 9);
      }
      this.mData.dialog.scan = false;

      if (Number.isNaN(decodedString - 1)) {
        //tp :
        //decode
        try {
          this.mData.dataDefault.QRCode = decodedString;
          let encodeURI = encodeURIComponent(decodedString);
          const ForeignerQr = await ForeignerQrApi.list({
            filters: "qr=" + encodeURI + "|khai_bao.tiem_chung.qr="+ encodeURI + "|xet_nghiem.qr_code=" + encodeURI + "&trang_thai=da_nhap_canh",
            fields: "id,foreigner_id,qr,trang_thai,visa,nhap_canh"
          });
          // this.mData.dataDefault.dataForeignerQr = ForeignerQr.result[0];
          const foreigner = await ForeignerApi.findById(
            ForeignerQr.result[0].foreigner_id
          );
          if(ForeignerQr.result[0].visa){
          const profileVisa = await ProfileApi.findById(
            ForeignerQr.result[0].visa.nguoi_duyet
          );

          this.mData.dataDefault.profileVisa = profileVisa.result;
          }

          try {
            const profileNhapCanh = await ProfileApi.findById(
              ForeignerQr.result[0].nhap_canh.hai_quan
            );
            this.mData.dataDefault.profileNhapCanh = profileNhapCanh.result;
            this.mData.dataDefault.dataForeignerQr = Object.assign(
              ForeignerQr.result[0],
              foreigner.result
            );
            if(this.mData.dataDefault.dataForeignerQr){
              if(this.mData.dataDefault.dataForeignerQr.visa && this.mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet){
                this.mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet = moment(
                  this.mData.dataDefault.dataForeignerQr.visa.thoi_diem_duyet
                ).format("DD/MM/YYYY HH:mm");
              }

            }

            this.mData.dataDefault.dataForeignerQr.nhap_canh.thoi_diem_nhap_canh = moment(
              this.mData.dataDefault.dataForeignerQr.nhap_canh
                .thoi_diem_nhap_canh
            ).format("DD/MM/YYYY HH:mm");

            this.circleUrl =
              ExtensionService.urlImg +
              this.mData.dataDefault.dataForeignerQr.anh_chan_dung_id;

            //show popup user
            this.mData.dialog.modalUser = true;

          } catch (error) {
            window.toastr.error("Mã QR không tồn tại!");
            this.mData.dataDefault.QRCode = "";
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          window.toastr.error("Mã QR không tồn tại");
          this.mData.dialog.modalUser = false;
          this.mData.dataDefault.QRCode = "";
        }
      } else {
        //  ! Number.isNaN(decodedString - 1)

        //decode
        try {
          this.mData.dataDefault.QRCode = decodedString;
          let khachDuLichId;
          // this.mData.dataFormCheckin.cardCode = this.mData.dataDefault.QRCode;

          let resNguoiCheckinId = await AccountApi.getUserIdOrFetchAcsUser(
            {cardCode: decodedString}
          );
          // debugger;
          if (resNguoiCheckinId.result) {
            khachDuLichId = resNguoiCheckinId.result;
          } else {
            khachDuLichId = null;
          }

          const resKhachDuLichApi = await KhachDuLichApi.findById(khachDuLichId);
          // debugger;

          this.mData.dataDefault.dataQrKhachDuLich =
            resKhachDuLichApi.result
          if(resKhachDuLichApi.result && resKhachDuLichApi.result.avatar_id){
            this.circleUrlInfo =
            ExtensionService.urlImg + resKhachDuLichApi.result.avatar_id;

          }
          try {
            const resDangKyChuongTrinhApi = await DangKyChuongTrinhApi.list({
              filters: "user_id=" + resKhachDuLichApi.result.id,
              fields: "id,du_lieu_khai_bao"
            });
            if(resDangKyChuongTrinhApi.result&&resDangKyChuongTrinhApi.result[0]&&resDangKyChuongTrinhApi.result[0].du_lieu_khai_bao){
              this.mData.dataDefault.tieu_chi = resDangKyChuongTrinhApi.result[0].du_lieu_khai_bao.tieuchi1.split(
                "\n"
              );
            }
            else{
              this.mData.dataDefault.tieu_chi=null;
            }


            //show popup modalInfo
            this.mData.dialog.modalInfo = true;

          } catch (error) {
            window.toastr.error("Mã QR không tồn tại!");
            this.mData.dataDefault.QRCode = "";
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          window.toastr.error("Mã QR không tồn tại");
          this.mData.dialog.modalInfo = false;
          this.mData.dataDefault.QRCode = "";
        }
      }

      // this.mData.dialog.scan = false;
    },
    checkBody(){
      if(this.mData.dialog.modalUser|| this.mData.dialog.modalInfo){
        $('body').css('overflow','hidden')
      }
    },
    myEventHandler() {
      this.calcStyle();
    },
    calcStyle() {
      let bgHeight = this.$refs.bg.clientHeight;
      let bgWidth =  bgHeight / 1.41;
      const qrWidth = bgWidth * 0.2;
      this.cssStyle.bgWidth = bgWidth + "px";
      this.cssStyle.qrWidth = `${Math.floor(bgWidth / 6.3)}px`;
      this.cssStyle.qrHeight = bgHeight / 5.3;
      this.cssStyle.qrPosionLeft = `${Math.floor((bgWidth - qrWidth) / 1.38)}px`;
      this.cssStyle.qrPosionTop = `${Math.floor((bgHeight - qrWidth) / 1.9)}px`;

    },
  },
  async mounted() {
    await this.fn_hashUrl();
    await this.fn_initDataDefault();
    await this.fn_initTable();
    window.scroll({
      top: 1,
    });
    window.scroll({
      top: 0,
    });
    window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("scroll", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("scroll", this.myEventHandler);
  },
};
</script>

<style lang="scss">
.cell {
  .ico {
    .fas,.far {
      font-size: 22px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.el-autocomplete.inline-input{
  width:100%;
}
.qr-code img {
  margin: 0 auto;
}
.qr_code_wrap > div,
.qr_code_download > div {
  min-width: 18rem !important;
}
.scroll-bar::-webkit-scrollbar {
  width: 0;
}
.el-dialog__header{
  border-bottom: 1px solid #fff;
  background: #fff;
}
.el-dialog__headerbtn{
  margin-top:5px;
}
.el-avatar-d > img{
  width:100%
}
.el-select-dropdown__wrap{
  // max-width: 274px;
}
@media only screen and (max-width: 427px) {
  // .button_wrap {
  //   display: flex;
  //   position: absolute;
  //   bottom: 1rem;
  //   left: 7;
  //   left: 7.2rem;
  // }
}
// @media only screen and (width: 320px) {
//   .button_wrap{
//     .tai_app{
//       margin-top:5px
//     }
//   }
// }
// @media only screen and (width: 768px) {
//   .button_wrap {
//     display: flex;
//   }
// }
// @media only screen and (width: 1024px) {
//   .button_wrap {
//     display: flex;
//   }
// }
@media only screen and (max-width: 577.98px) {
  .pagination-wrap {
    text-align: left !important;
  }
  .el-pagination {
    &__total {
      position: absolute;
      left: 1rem;
    }
    &__sizes {
      margin-left: 4rem;
      display: block !important;
      margin-bottom: 0.5rem;
    }
    &__jump {
      position: absolute;
      right: 1rem;
      top: 5px;
    }
  }
  //bug canvas
  .canvasjs-chart-toolbar {
    display: none;
  }
}
.card-body-custom {
  height: calc(100vh - 250px);
}

.card-body-custom > * {
  height: 100%;
}

.bg-qr {
  display: flex;
  height: 100%;
  width: 100%;
  font-size: 10px;
}
#check-in-ddat-qr .el-dialog{
  width: 30%;
  margin: 0 auto 0;
}

@media (min-width: 1012px ) and (max-width: 1296px) {
  .button_wrap{
    max-width: 60%;
  }
}
@media (min-width: 991px ) and (max-width: 1011px) {
  .button_wrap{
    max-width: 65%;
  }
}
@media (min-width: 720px ) and (max-width: 879px) {
  .button_wrap{
    max-width: 67%
  }
}
@media (min-width: 615px ) and (max-width: 719px) {
  .button_wrap{
    max-width: 80%
  }
}
@media (max-width: 486px) {
  .button_wrap{
    max-width: 70%
  }
  .tai_app,.huong_dan{
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
</style>
